import * as React from "react";
import { BarChart } from "@mui/x-charts/BarChart";
import { Box, Typography } from "@mui/material";
import { GraphDataItem } from "./DashboardTypes";

interface UploadBarChartProps {
  data: GraphDataItem[];
  selectedSection: string;
}

const UploadBarChart: React.FC<UploadBarChartProps> = ({
  data,
}) => {

  const xLabels = data.map((item) => item.section);
  const uData = data.map((item) => item.upload_count);
  const pData = data.map((item) => item.sum_of_pending_count);
  const cData = data.map((item) => item.sum_of_approved_count);

  return (
    <>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          gap: "20px",
          p: "20px",
          pb: "0px",
        }}
      >
        <Typography
          sx={{fontSize: "16px", fontWeight: "600", maxWidth: "50%" }}
        >
          Upload Summary
        </Typography>
      </Box>

      <Box
        sx={{
          maxWidth: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          mb: 2,
        }}
      >
        <BarChart
          width={550}
          height={650}
          borderRadius={10}
          barLabel="value"
          margin={{ top: 150, bottom: 50 }}
          xAxis={[{ data: xLabels, scaleType: "band" }]}
          yAxis={[{ valueFormatter: () => "" }]}
          series={[
            {
              data: uData,
              label: "Count of Uploads",
              id: "pvId",
              color: "#DAC843",
            },
            {
              data: pData,
              label: "Count of Pending",
              id: "uvId",
              color: "#D96A6A",
            },
            {
              data: cData,
              label: "Count of Approved",
              id: "cvId",
              color: "#85AF85",
            },
          ]}
          sx={{
            "& .MuiChartsAxis-tickLabel": {
              fill: "#000000 !important",
              fontSize: "14px",
            },
            "& .MuiChartsAxis-label": {
              fill: "#000000 !important",
              fontSize: "14px",
            },
            "& .MuiChartsLegend-series text": {
              fill: "#000000 !important",
              fontSize: "14px",
              fontWeight: "bold",
            },
            "& .MuiChartsLegend-series-pvId": {
              transform: "translate(60%, 20px)",
            },
            "& .MuiChartsLegend-series-uvId": {
              transform: "translate(60%, 55px)",
            },
            "& .MuiChartsLegend-series-cvId": {
              transform: "translate(60%, 90px)",
            },
          }}
        />
      </Box>
    </>
  );
};

export default UploadBarChart;
